import type { ReactNode, TextareaHTMLAttributes } from 'react'

import { forwardRef } from 'react'
import { cn } from '@/lib/utils'

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    label?: ReactNode
    error?: string
}

const base = 'block w-full rounded-card border border-transparent bg-white/80 px-4 py-3 text-base text-neutral-900 placeholder:text-neutral-400 shadow-[inset_0_0_0_1px_rgba(0,0,0,0.04)] focus:border-brand-red/50 focus:bg-white focus:outline-none focus:ring-4 focus:ring-brand-red/15 transition-colors'

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, label, error, id, rows = 5, ...props }, ref) => {
    const textareaId = id ?? props.name

    return (
        <div className='flex flex-col gap-1.5'>
            {label ? (
                <label htmlFor={textareaId} className='text-sm font-medium text-neutral-700'>
                    {label}
                </label>
            ) : null}

            <textarea
                ref={ref}
                id={textareaId}
                rows={rows}
                aria-invalid={Boolean(error) || undefined}
                aria-describedby={error ? `${textareaId}-error` : undefined}
                className={cn(base, 'resize-y', error && 'ring-2 ring-brand-red/40 focus:ring-brand-red/30', className)}
                {...props}
            />

            {error ? (
                <p id={`${textareaId}-error`} className='text-xs font-medium text-brand-red'>
                    {error}
                </p>
            ) : null}
        </div>
    )
})

Textarea.displayName = 'Textarea'

export default Textarea
